import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Operator } from 'rxjs/Operator';
import { ApiHttp } from './api-http.service';
import { RawStoreState } from './helpers';

export class ObjectObservable<T> extends Observable<T> {
  constructor(
    private ref$: any,
    private apiHttp: ApiHttp,
    private store: Store<RawStoreState>,
    source: Observable<any>,
  ) {
    super();
    this.source = source;
  }

  lift<R>(operator: Operator<T, R>): ObjectObservable<R> {
    const observable = new ObjectObservable<R>(
      this.ref$,
      this.apiHttp,
      this.store,
      this,
    );
    observable.operator = operator;
    return observable;
  }

  set(value: any): Observable<void> {
    return Observable.of(undefined);
  }
  update(value: Object): Observable<void> {
    return Observable.of(undefined);
  }
  remove(): Observable<void> {
    return Observable.of(undefined);
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/object-observable.ts